import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Avatar,
  Chip,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const BadgeTable = ({
  badges,
  handleOpenViewBadgeDialog,
  handleOpenEditDialog,
  setConfirmDelete,
  getRarityColor,
}) => {
  const { t } = useTranslation(['badges', 'common']);
  return (
    <TableContainer component={Paper} elevation={0}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>{t('badges:management.badges.image')}</TableCell>
            <TableCell>{t('badges:management.badges.name')}</TableCell>
            <TableCell>{t('badges:management.badges.category')}</TableCell>
            <TableCell>{t('badges:management.badges.rarity')}</TableCell>
            <TableCell>{t('badges:management.badges.tier')}</TableCell>
            <TableCell>{t('badges:management.badges.isSecret')}</TableCell>
            <TableCell align="center">
              {t('badges:management.badges.actions')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {badges.map((badge) => (
            <TableRow key={badge._id}>
              <TableCell>
                <Avatar
                  src={badge.image}
                  alt={badge.name}
                  sx={{
                    width: 50,
                    height: 50,
                    border: `2px solid ${getRarityColor(badge.rarity)}`,
                  }}
                />
              </TableCell>
              <TableCell>{badge.name}</TableCell>
              <TableCell>
                <Chip
                  label={t(`badges:category.${badge.category}`)}
                  size="small"
                />
              </TableCell>
              <TableCell>
                <Chip
                  label={t(`badges:rarity.${badge.rarity}`)}
                  size="small"
                  sx={{
                    bgcolor: getRarityColor(badge.rarity),
                    color: '#fff',
                  }}
                />
              </TableCell>
              <TableCell>
                <Chip label={t(`badges:tier.${badge.tier}`)} size="small" />
              </TableCell>
              <TableCell>
                {badge.isSecret
                  ? t('common:status.true')
                  : t('common:status.false')}
              </TableCell>
              <TableCell align="center">
                <Tooltip title={t('common:actions.view')}>
                  <IconButton
                    size="small"
                    onClick={() => handleOpenViewBadgeDialog(badge)}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t('common:actions.edit')}>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => handleOpenEditDialog(badge)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t('common:actions.delete')}>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => setConfirmDelete({ open: true, badge })}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BadgeTable;
